import { Select } from "antd";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useViewAllOwners } from "@/datasources/superadmin-query";
import { setSelectedOwner } from "@/stores/slice/ownerslice/ownerslice";

const OwnerDropdown = () => {
  const dispatch = useDispatch();
  const { control, setValue } = useForm({});

  const { data: ownerlist } = useViewAllOwners();
  const { selectedOwner } = useSelector((state) => state.owner);
  const ownerId = localStorage.getItem("ownerId");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ownerlistdata = ownerlist?.data?.length
    ? ownerlist?.data?.map((x) => ({
        label: x?.user?.username,
        value: x?.user?.user_id,
      }))
    : [];

 
  useEffect(() => {
    if (ownerlistdata && ownerlistdata.length > 0) {
      const initialShipId = ownerId || ownerlistdata[0].value;
      const selectedownerinfo = ownerlistdata.find(
        (item) => item.value === initialShipId
      );
      if (selectedownerinfo) {
        dispatch(setSelectedOwner(selectedownerinfo.value));
        setValue("ownerId", selectedownerinfo.value);
        localStorage.setItem("ownerId", selectedownerinfo.value);
      }
    }
  }, [ownerlistdata, selectedOwner, ownerId, dispatch, setValue]);

  const onChangeShip = (value) => {
    dispatch(setSelectedOwner(value));
    localStorage.setItem("ownerId", value);
    window.location.reload();
  };

  return (
    ownerlistdata &&
    ownerlistdata?.length && (
      <Controller
        name="ownerId"
        control={control}
        render={({ field }) => (
          <Select
            showSearch  
            value={selectedOwner}
            style={{ width: "20vh" }}
            filterSort={(optionA, optionB) =>
              (optionA.label ?? "")
                .toLowerCase()
                .localeCompare((optionB.label ?? "").toLowerCase())
            }
            {...field}
            onChange={(value) => {
              field.onChange(value);
              onChangeShip(value);
            }}
            placeholder="Select Owner"
          >
            {ownerlistdata.map((x) => (
              <Select.Option key={x.value} value={x.value}>
                {x.label} -{x?.value}
              </Select.Option>
            ))}
          </Select>
        )}
      />
    )
  );
};

export default OwnerDropdown;
